import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchPPGamesData, fetchPragmaticPolasData } from '../../store/actions/ppGameAction';
import Loading from '../Loading';

const PragmaticCard = (data) => {
  const dispatch = useDispatch();
  const { ppNames, ppImages, pragmaticPolas, nameAndImagesIsLoading } = useSelector((state) => state.ppGameReducer);

  useEffect(() => {
    dispatch(fetchPragmaticPolasData());
    dispatch(fetchPPGamesData());
  }, [dispatch]);

  if (data.isLoading || nameAndImagesIsLoading)
    return (
      <>
        <Loading />
      </>
    )

  return (
    <>
      <h2>Pragmatic</h2>
      <section className="container px-3 sm:px-12 mx-auto" id="pp">
        <div className='grid grid-cols-2 lg:grid-cols-5 gap-4 justify-items-center'>
          {
            ppNames.map((ppName, i) => {
              return (
                <div key={i} className="w-full grid justify-items-center bg-item p-3">
                  <div className="relative flex-shrink-0">
                    <img width={"150px"} src={ppImages[i]} alt={ppName} />
                  </div>
                  <div className="grid box-content text-center content-center capitalize mb-3">
                    <span className="game-name h-12 grid content-center">{ppName}</span>
                    <div className="jam px-5 py-3 mb-3">
                      <span>Jam Gacor: </span>
                      <span className="jamGacor">
                        {data.jamGacors[i] ? data.jamGacors[i].value1 : ''}
                      </span>
                    </div>
                    <span>Pola: </span>
                    <span className="v1pp">{pragmaticPolas[i] ? pragmaticPolas[i].value1 : ''}</span>
                    <span className="v2pp">{pragmaticPolas[i] ? pragmaticPolas[i].value2 : ''}</span>
                    <span className="v3pp">{pragmaticPolas[i] ? pragmaticPolas[i].value3 : ''}</span>
                  </div>
                  <div className='single-bar relative items-center'>
                    <div className='absolute font-bold rtpValue' style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                      <span>{data.rtps[i] ? data.rtps[i].value1 : ''}%</span>
                    </div>
                    <div className="single-bar__fill bar animated-gradient" style={{ width: `${data.rtps[i] ? data.rtps[i].value1 : ''}%` }}></div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </section >
    </>
  );
};

export default PragmaticCard;